import React, { useEffect, useState, useContext } from 'react';
import styles from './ApplicationsPage.module.scss';
import FacilityDetails from '../../Molecules/detailsBox/facilityDetailsBox';
import TableTopHeader from '../../Molecules/TableTopHeader/ApplicationsTableTopHeader';
import ApplicantsTable from '../../Molecules/Applications/ApplicantsTable';
import {
  DetailsContext,
  PageTitleContext,
} from '../../HOC/GeneralBody/GeneralBody';

import {
  useFetchApplicants,
  useFetchFacility,
  useExportTableFacility,
  useFetchSingleFacility,
} from '../../../Hooks/Applications';

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const HeaderAttr = useContext(PageTitleContext);
  const Details = useContext(DetailsContext);
  const [selected, setSelected] = useState('facility');
  const [facilityNumber, setFacilityNumber] = useState(0);
  const [applicationId, setApplicationId] = useState('');
  const [search, setSearch] = useState();
  const [order, setOrder] = useState(['', 'asc']);
  const [mode, setMode] = useState('facility');
  const facilityTableHeader = [
    { name: 'عنوان الحدث', originalName: 'eventTitle' },
    { name: 'اسم المنسق', originalName: 'coordinatorName' },
    { name: 'البريد الإلكتروني', originalName: 'email' },
    { name: 'رقم الهاتف', originalName: 'phoneNumber' },
    { name: 'القاعة المطلوبة', originalName: 'requestedHall' },
    // { name: 'التاريخ', originalName: 'facilityDates' },
    { name: 'تم الإنشاء في', originalName: 'createdOn' },
  ];

  const {
    data: applicants,
    refetch: refetchApplicants,
    isLoading: isLoading,
  } = useFetchApplicants({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: facility,
    refetch: refetchFacility,
    isLoading: isLoading3,
  } = useFetchFacility({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: facilityPrint,
    refetch: refetchFacilityPrint,
    isLoading: isLoading00000,
  } = useFetchFacility({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: FacilitybyId, refetch: refetchSingleFacility } =
    useFetchSingleFacility(Details.details);

  const exportFacilityTable = useExportTableFacility();
  const handleExportTable = async () => {
    try {
      var data = await exportFacilityTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'FacilitiesTable';
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('Unexpected data type. Expected string.');
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  useEffect(() => {
    if (Details.details) {
      HeaderAttr.setMoveRight('40px');
      refetchSingleFacility();
      HeaderAttr.setPathName('تفاصيل المرفق');
    } else {
      HeaderAttr.setMoveRight('2px');
      HeaderAttr.setPathName('المرافق');
      Details.setDetails(null);
    }
  }, [Details.details]);

  useEffect(() => {
    refetchFacility();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (facility && !facilityNumber) {
      setFacilityNumber(facility && facility.data.totalCount);
    }
  }, [facility]);

  const [moveRight, setMoveRight] = useState(false);

  useEffect(() => {
    setSearch('');
    setPage(1);
    setPageSize(10);
    setOrder(['', 'asc']);
  }, [selected]);

  return (
    <>
      {!Details.details ? (
        <div className={styles['container']}>
          <div className={styles['search-container']}>
            <div className={styles['table-container']}>
              <TableTopHeader
                rowsCount={applicants}
                mode={mode}
                handleExport={handleExportTable}
                search={search}
                setSearch={setSearch}
                title='Facilities Table'
                data={facilityPrint?.data}
                refetch={refetchFacilityPrint}
                tableHeader={facilityTableHeader}
              />
              <ApplicantsTable
                data={facility?.data}
                tableHeader={facilityTableHeader}
                mode={mode}
                page={Page}
                setPage={setPage}
                pageSize={PageSize}
                setPageSize={setPageSize}
                isApplicantsLoading={isLoading}
                setDetails={Details.setDetails}
                details={Details.details}
                setApplicationId={setApplicationId}
                order={order}
                setOrder={setOrder}
                refetch={refetchFacility}
                setMoveRight={setMoveRight}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <FacilityDetails
            data={FacilitybyId && FacilitybyId.data}
            setDetails={Details.setDetails}
            details={Details.details}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
